module.exports = __webpack_public_path__ + "7e35496f82cd0803cb2836120b9d5acb.svg";